import { MutationHookOptions, useMutation } from "@apollo/client";
import mutationGQL from "@whoppah/apollo/mutation/merchant/setMerchantTradeDiscount.graphql";
import {
  SetMerchantTradeDiscountMutation,
  SetMerchantTradeDiscountMutationVariables,
} from "@whoppah/apollo/schema";

export const useSetMerchantTradeDiscountMutation = (
  options?: MutationHookOptions<
    SetMerchantTradeDiscountMutation,
    SetMerchantTradeDiscountMutationVariables
  >
) => {
  return useMutation(mutationGQL, options);
};
